import { render, staticRenderFns } from "./MailPreview.vue?vue&type=template&id=12f7d522&"
import script from "./MailPreview.vue?vue&type=script&lang=js&"
export * from "./MailPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports